import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { normalizeLang } from "../i18n";
import { getSystemStrings } from "../strings/systemStrings";
import { fetchPublicSettings } from "../services/publicSettings";
import { useAuth } from "../auth/AuthContext";
import "./HelpNow.css";

function useQuery() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return {
    lang: normalizeLang(params.get("lang") || "he"),
    returnTo: params.get("return") || "/journey/select?lang=he",
  };
}

export default function HelpNow() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { lang, returnTo } = useQuery();
  const copy = getSystemStrings(lang, user?.gender).helpNow;
  const [localNumbers, setLocalNumbers] = React.useState([]);
  const [showNumbers, setShowNumbers] = React.useState(false);

  React.useEffect(() => {
    let active = true;
    fetchPublicSettings()
      .then((data) => {
        if (!active) return;
        const raw = data?.emergencyNumbers || {};
        const byLang = raw.byLang || raw;
        const byCountry = raw.byCountry || {};
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
        const country =
          timezone.startsWith("America/") ? "US" :
          timezone.startsWith("Europe/Madrid") ? "ES" :
          timezone.startsWith("Asia/Jerusalem") ? "IL" :
          null;
        const list =
          (country && Array.isArray(byCountry[country]) ? byCountry[country] : null) ||
          (Array.isArray(byLang?.[lang]) ? byLang[lang] : []) ||
          [];
        setLocalNumbers(Array.isArray(list) ? list : []);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [lang]);
  const contactUrl =
    (typeof window !== "undefined" && window.INNERVEICE_CONTACT_URL) || "";

  return (
    <div className="help-now-page" dir={lang === "he" ? "rtl" : "ltr"}>
      <div className="help-now-card">
        <h1>{copy.title}</h1>
        {copy.body.map((line, idx) => (
          <p key={`help-${idx}`}>{line}</p>
        ))}
        {showNumbers && localNumbers.length > 0 && (
          <div className="help-now-numbers">
            {localNumbers.map((num) => (
              <div key={num}>{num}</div>
            ))}
          </div>
        )}
        <div className="help-now-actions">
          <button type="button" className="help-now-primary" onClick={() => navigate(returnTo)}>
            {copy.back}
          </button>
          {localNumbers.length > 0 && (
            <button
              type="button"
              className="help-now-secondary"
              onClick={() => setShowNumbers((v) => !v)}
            >
              {copy.showLocal}
            </button>
          )}
          {contactUrl && (
            <a className="help-now-secondary" href={contactUrl}>
              {copy.messageClose}
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
